import { OverlayLayerContext, useOverlayLayer } from "./OverlayLayer";
import { Drawer as BaseDrawer } from "@base-ui/react/drawer";
import { cn } from "../lib/cn";
import { dialogBackdropClassName } from "./Dialog";

export interface DrawerContentProps extends Omit<BaseDrawer.Popup.Props, "className"> {
  className?: string;
}

function Content({ className, children, ...props }: DrawerContentProps) {
  const layer = useOverlayLayer("modal");
  return (
    <OverlayLayerContext value={layer}>
      <BaseDrawer.Portal>
        <BaseDrawer.Backdrop
          style={{ zIndex: `calc(${layer} - 1)` }}
          data-slot="drawer-backdrop"
          className={dialogBackdropClassName}
        />
        <BaseDrawer.Viewport
          style={{ zIndex: layer }}
          className="fixed inset-0 z-modal flex justify-end"
        >
          <BaseDrawer.Popup
            data-slot="drawer-content"
            className={cn(
              "flex h-full min-h-0 w-full max-w-xl flex-col border-l border-border bg-surface pt-[env(safe-area-inset-top,0px)] pr-[env(safe-area-inset-right,0px)] pb-[env(safe-area-inset-bottom,0px)] pl-[env(safe-area-inset-left,0px)] text-fg shadow-lg outline-none [transform:translateX(var(--drawer-swipe-movement-x,0px))] transition-transform duration-base ease-enter data-starting-style:translate-x-full data-ending-style:translate-x-full data-swiping:transition-none motion-reduce:transition-none",
              className,
            )}
            {...props}
          >
            {children}
          </BaseDrawer.Popup>
        </BaseDrawer.Viewport>
      </BaseDrawer.Portal>
    </OverlayLayerContext>
  );
}

/** A dismissible side drawer; content scrolls independently of its header. */
export const Drawer = {
  Root: BaseDrawer.Root,
  Trigger: BaseDrawer.Trigger,
  Content,
  Title: BaseDrawer.Title,
  Description: BaseDrawer.Description,
  Close: BaseDrawer.Close,
};
